import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ErrorCodes } from '../../../error-treatment/enum/error-code.enum';
import { IServiceResponseWidgets } from '../../models/services/response-app/response-app-widgets.interface';

@Component({
  selector: 'app-modal-content-wrapper',
  templateUrl: './modal-content-wrapper.component.html',
  styleUrls: ['./modal-content-wrapper.component.scss']
})
export class ModalContentWrapperComponent implements OnInit {
  isLoading = true;
  showError: boolean;
  errorCode: ErrorCodes;

  constructor(
    private cdref: ChangeDetectorRef,
    private dialogRef: MatDialogRef<ModalContentWrapperComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IServiceResponseWidgets
  ) {}

  ngOnInit() {
    this.createMicrofrontendModalElements();
  }

  /**
   * Create modal microfrontend script elements
   */
  createMicrofrontendModalElements(): void {
    if (document.getElementById(`script-${this.data.tag_html}`)) {
      this.isLoading = false;
      this.createMicrofrontendModalHTMLTag(this.data);
      return;
    }

    const script = document.createElement('script');
    script.src = this.data.url;
    script.id = `script-${this.data.tag_html}`;

    script.onload = () => (this.isLoading = false);

    script.onerror = this.onScriptError.bind(this);

    document.body.appendChild(script);

    this.createMicrofrontendModalHTMLTag(this.data);
  }

  /**
   * Creates modal HTML tag and add to modal section
   * @param modal Modal Microfrontend info
   */
  createMicrofrontendModalHTMLTag(modal: IServiceResponseWidgets): void {
    this.cdref.detectChanges();
    const modalElement = document.createElement(modal.tag_html);
    const modalWrapper = document.getElementById(`modal-${modal.tag_html}`);
    if (modalWrapper) {
      modalWrapper.appendChild(modalElement);
    }
  }

  closeModal() {
    this.dialogRef.close();
  }

  onScriptError() {
    this.showError = true;
    this.errorCode = ErrorCodes.INVALID_MFE;
    const el = document.getElementById(`script-${this.data.tag_html}`);
    el?.parentNode?.removeChild(el);
  }
}
